import * as React from 'react'
import { TokenNavLink } from 'catena/er2_ui'

// @flow
type Props = {
    idx: number,
    item: { id: string, link: string, name: string, subheader: boolean, },
    active: boolean,
    theme: { active: string, link: string, tableOfContentsBarItem: string },
    token: { value: string },
}

function TableOfContentsBarItem(props: Props) {
    // Check for '/' in id, in which case we assume that the item is a subheader.
    const classNames = `${props.theme.tableOfContentsBarItem} ${props.theme.link}
        ${props.active ? props.theme.active : ''}
        ${props.item.id.indexOf('/') >= 0 ? props.theme.tableOfContentsBarSubItem : ''}`
    return (
        <TokenNavLink
            className={classNames}
            role="button"
            tabIndex={props.idx}
            to={props.item.link || '#'}
            token={props.token}
            onClick={evt => props.onClick(props.item.id)}
        >
            {props.item.name}
        </TokenNavLink>
    )
}

export default TableOfContentsBarItem
